<template>
  <div v-loading="oLoading.detail">
    <QS-h3-title v-if="!bizId">
      <template slot="title">维保单详情</template>
      <el-button v-if="tabType" slot="right" @click="goBack">返回</el-button>
    </QS-h3-title>
    <div class="splitline mt16 mb16"></div>
    <QS-h4-title title="维保单信息" />
    <el-form label-width="140px">
      <column-box :source="source" :list="list" label-width="140px">
        <el-form-item :label="'结算单附件' + columnSeparator" class="alone">
          <div v-if="this.fileList.length > 0">
            <div
              v-for="(item, index) in this.fileList"
              :key="'fileList' + index"
            >
              <p v-down="{ url: item.url, name: item.name }" class="blue">
                <i class="el-icon-document"></i>
                {{ item.name }}
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="'处理备注' + columnSeparator" class="alone remark-form-item">
          <div>{{ source.remarks || '--'}}</div>
        </el-form-item>
        <el-form-item :label="'送修原因' + columnSeparator" class="alone remark-form-item">
          <div>{{ source.reasonForRepair || '--' }}</div>
        </el-form-item>
      </column-box>
    </el-form>
    <maintenancePhoto :imageList="imageList" />
    <AddPay
      showType="3"
      :driverWarningPayList="driverWarningPayList"
      :dataList="source.maintenanceItemInfo || []"
      :countAllPay="source.totalAmount"
    />
    <driverWarningPay :driverWarningPayList="driverWarningPayList" />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { maintenanceDetail, getMaintenanceDetail } from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'
import AddPay from '../components/addPay.vue'
import driverWarningPay from '../components/driverWarningPay.vue'
import maintenancePhoto from '../components/maintenancePhoto.vue'
import config from './config'

const maintenanceState = {
  '-1': '已取消',
  1: '待使用',
  2: '维修中',
  3: '已完成',
  '-2': '退款中',
}
const payState = {
  0: '待支付',
  1: '已支付',
  '-1': '支付失败',
}
const refundState = {
  0: '退款中',
  1: '退款完成',
  '-1': '退款取消',
}
const settlementState = {
  1: '未结算',
  2: '已结算',
}

const sourceType = {
  0: '系统录入',
  1: '维修厂',
  2: '个人消费',
}

const receivableState = {
  0: '未完成',
  1: '已完成',
  2: '已关闭',
}

const rentPlanType = {
  1: '个人租赁方案',
  2: '企业租赁方案',
}
export default {
  components: {
    AddPay,
    driverWarningPay,
    maintenancePhoto,
  },
  data() {
    const { infoList } = config.call(this)
    return {
      oLoading: {
        detail: false,
      },
      tabType: '', // 客户&车辆详情/个人租赁跳转到个人租赁详情的类型
      list: infoList,
      source: {},
      /* 上传假数据 */
      fileList: [],
      params: {
        id: null,
      },
      driverWarningPayList: [], // 司机警示金
      imageList: [], // 维保图片
      bizId: '', // 审批ID
    }
  },
  mounted() {
    const { id, bizType, bizId, tabType } = this.$route.query
    this.tabType = tabType
    this.bizId = bizId
    if (id) {
      this.params.id = bizType ? bizId : id
      this.getList(this.params)
    }
  },
  methods: {
    // 返回上一级
    goBack() {
      this.$router.go(-1)
    },
    async getList(res) {
      this.oLoading.detail = true
      try {
        const { code, data } = await getMaintenanceDetail(res)
        this.oLoading.detail = false
        if (code === 1) {
          let typeT = data.type
          let MS = data.maintenanceState
          let SS = data.settlementState

          // 维保类型
          typeT = selectOption.maintenanceTypeDict[typeT]
          // 维保状态
          MS = selectOption.maintenanceStateDict[MS]
          // 结算状态
          SS = selectOption.settlementStatusDict[SS]
          data.incomeKm = data.incomeKm || '--'
          data.expenseBearingParty = selectOption.costBearingParty[data.expenseBearingParty] || '--'
          this.source = {
            ...data,
            type: typeT,
            maintenanceState: MS,
            settlementState: SS,
            maintenanceStateName: maintenanceState[data.maintenanceState],
            payStateName: payState[data.payState],
            refundStateName: refundState[data.refundState],
            settlementStateName: settlementState[data.settlementState],
            sourceTypeName: sourceType[data.sourceType],
            rentPlanTypeText: rentPlanType[data.rentPlanType],
          }
          this.fileList = this.getEchoUploadFileData(data.attachment, true)
          let warningItemInfo = []
          if (Array.isArray(data.warningItemInfo)) {
            warningItemInfo = data.warningItemInfo.map((item) => {
              item.receivableStateName = receivableState[item.receivableState] || '--'
              return item
            })
          }
          this.driverWarningPayList = warningItemInfo
          // 维保图片处理
          const _imageData = JSON.parse(data.photo)
          let tempImageList
          if (Number(data.type) === 2) { // 保养
            tempImageList = [
              {
                label: '进厂图片',
                value: this.getImageList(_imageData.enterFactoryPictures),
              },
              {
                label: '仪表盘照片',
                value: this.getImageList(_imageData.dashboardPictures),
              },
              {
                label: '施工完成照片',
                value: this.getImageList(_imageData.finishPictures),
              },
            ]
          } else if (Number(data.type) === 1) { // 维修
            tempImageList = [
              {
                label: '仪表盘照片',
                value: this.getImageList(_imageData.dashboardPictures),
              },
              {
                label: '进厂图片',
                value: this.getImageList(_imageData.enterFactoryPictures),
              },
              {
                label: '维修更换部件照片',
                value: this.getImageList(_imageData.maintenancePictures),
              },
              {
                label: '事故现场照片',
                value: this.getImageList(_imageData.accidentScenePictures),
              },
              {
                label: '责任认定书',
                value: this.getImageList(_imageData.responsibilityPictures),
              },
              {
                label: '定损单',
                value: this.getImageList(_imageData.lossOrderPictures),
              },
              {
                label: '施工完成照片',
                value: this.getImageList(_imageData.finishPictures),
              },
            ]
          } else { // 事故
            tempImageList = [
              {
                label: '进厂图片',
                value: this.getImageList(_imageData.enterFactoryPictures),
              },
              {
                label: '维修更换部件照片',
                value: this.getImageList(_imageData.maintenancePictures),
              },
              {
                label: '事故现场照片',
                value: this.getImageList(_imageData.accidentScenePictures),
              },
              {
                label: '责任认定书',
                value: this.getImageList(_imageData.responsibilityPictures),
              },
              {
                label: '定损单',
                value: this.getImageList(_imageData.lossOrderPictures),
              },
            ]
          }
          this.imageList = tempImageList
        }
      } catch (error) {
        this.oLoading.detail = false
      }
    },
    // 获取图片集合
    getImageList(image) {
      const arr = typeof image === 'string' ? JSON.parse(image) : image
      if (Array.isArray(arr) && arr.length > 0) {
        return arr.map((item) => item)
      } else {
        return []
      }
    },
  },
}
</script>
<style lang="less" scoped>
.blue {
  color: #2e7eff;
  display: inline-block;
  margin: 0;
}
::v-deep .alone ::v-deep .el-form-item__content {
  margin-left: 0px !important;
}
.remark-form-item {
  ::v-deep .el-form-item__label {
    width: 140px;
  }
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
    white-space: pre-wrap;
  }
}
</style>
